import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import aiAssistData from '../features/analytics/data/analyticsAiAssistData.json';

const AiAssistSessionContext = React.createContext(null);

export const formatAiAssistMessageTime = (value = dayjs()) => dayjs(value).format('h:mm A');

const buildInitialChatThread = () => {
    const initialChats = Array.isArray(aiAssistData?.initialChats) ? aiAssistData.initialChats : [];

    return initialChats.map((message) => ({
        ...message,
        timestamp: formatAiAssistMessageTime()
    }));
};

export const AiAssistSessionProvider = ({ children }) => {
    const initialChatThread = React.useMemo(() => buildInitialChatThread(), []);
    const [chatThread, setChatThread] = React.useState(initialChatThread);

    const contextValue = React.useMemo(() => ({
        chatThread,
        setChatThread,
        resetChatThread: () => setChatThread(buildInitialChatThread())
    }), [chatThread]);

    return <AiAssistSessionContext.Provider value={contextValue}>{children}</AiAssistSessionContext.Provider>;
};

AiAssistSessionProvider.propTypes = {
    children: PropTypes.node
};

export const useAiAssistSession = () => {
    const context = React.useContext(AiAssistSessionContext);

    if (!context) {
        throw new Error('useAiAssistSession must be used within AiAssistSessionProvider');
    }

    return context;
};
